var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-pm-preview" }, [
    _vm.description
      ? _c("p", { staticClass: "ctm-pm-preview__desc" }, [
          _vm._v(_vm._s(_vm.description))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeGateways.length
      ? _c(
          "div",
          { staticClass: "ctm-pm-preview__cards" },
          _vm._l(_vm.activeGateways, function(gw, idx) {
            return _c(
              "div",
              {
                key: gw.key,
                class: [
                  "ctm-pm-preview__card",
                  idx === 0 ? "ctm-pm-preview__card--selected" : ""
                ]
              },
              [
                _c("span", { staticClass: "ctm-pm-preview__icon" }, [
                  _vm._v(_vm._s(gw.icon))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "ctm-pm-preview__label" }, [
                  _vm._v(_vm._s(_vm.customLabel(gw.key) || gw.label))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ctm-pm-preview__check",
                    attrs: { "aria-hidden": "true" }
                  },
                  [_vm._v("✓")]
                )
              ]
            )
          }),
          0
        )
      : _c("p", { staticClass: "ctm-pm-preview__empty" }, [
          _vm._v("\n    No payment gateways enabled — go to "),
          _c("strong", [_vm._v("Payment Settings")]),
          _vm._v(" to enable one.\n  ")
        ]),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { staticClass: "contactum-help" }, [
          _vm._v(_vm._s(_vm.field.help))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }